/**
 * WordPress dependencies
 */
import { SelectControl, BaseControl, Button, TextControl } from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import { Fragment } from '@wordpress/element';
import { addFilter } from '@wordpress/hooks';

/**
 * External dependencies
 */

/**
 * Inner dependencies.
 */
// import { updateBlockStyle } from '../inline-styles';
// import Accordion from '../../../components/Accordion';
// import AnimationDropDown from '../../../components/animation-dropdown';
import IconPicker from '../../../components/icon-picker';
import blockInfo from '../constants';
const { hookPrefix } = blockInfo;

addFilter( `gutenify-block-${ hookPrefix }-options-tab-content`, `gutenify--${ hookPrefix }--inspectorControls--tab-content-basic`, ( content, props ) => {
	const { setAttributes, attributes } = props;
	const { icon } = attributes;
	return [
		...content,
		<Fragment key={ `gutenify--${ hookPrefix }--inspectorControls--tab-content-basic` }>
			<BaseControl label={ __( 'Icon' ) } id="button-icon">
				<IconPicker
					value={ icon?.name }
					onChange={ ( val ) => {
						setAttributes( { icon: {
							...icon,
							name: val,
						} } );
					} }

				/>
				<Button variant="link" onClick={ () => {
					setAttributes( { icon: {
						...icon,
						name: '',
					} } );
				} }>{ __( 'Remove icon' ) }</Button>
				{ icon?.name && <>
					<SelectControl
						label={ __( 'Icon Position' ) }
						onChange={ ( val ) => {
							const data = {
								icon: {
									...icon,
									position: val,
								},
							};
							setAttributes( data );
						} }
						value={ icon?.position }
						options={ [
							{ value: 'before', label: __( 'Before' ) },
							{ value: 'after', label: __( 'After' ) },
						] } />
					<TextControl label={ __( 'Icon spacing' ) } onChange={ ( val ) => {
						const data = {
							icon: {
								...icon,
								spacing: val,
							},
						};
						setAttributes( data );
					// updateBlockStyle( data, props );
					} } value={ icon?.spacing } min={ 0 } type="number" />
				</> }
			</BaseControl>
		</Fragment> ];
} );
